var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHangupMobile = function SvgHangupMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hangup-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.497 8.497a1.157 1.157 0 0 1 0 1.637l-7.86 7.86 7.86 7.862a1.157 1.157 0 0 1-1.636 1.636L18 19.632l-7.86 7.86a1.157 1.157 0 0 1-1.637-1.636l7.86-7.861-7.86-7.861a1.157 1.157 0 1 1 1.636-1.637L18 16.358l7.86-7.86a1.157 1.157 0 0 1 1.637 0Z",
    fill: "#fff",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.674 10.31a1.407 1.407 0 1 0-1.99-1.99L18 16.006 10.316 8.32a1.407 1.407 0 0 0-1.99 1.99l7.684 7.684-7.684 7.684a1.407 1.407 0 1 0 1.99 1.99L18 19.985l7.684 7.684a1.407 1.407 0 0 0 1.99-1.99l-7.684-7.684 7.684-7.684Z",
    stroke: "#fff",
    strokeOpacity: 0.85,
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hangup-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgHangupMobile;